"use client";

import { useEffect, useState } from "react";

// Mirrors Header.tsx's own scroll threshold (window.scrollY > 200) for when
// the nav bar switches to `fixed top-0` (41px tall). The rail needs to know
// the same thing so its sticky offset can drop from 210px (below the full,
// unscrolled header stack) to 41px (flush under the now-fixed nav) — using a
// fixed 210px offset always left a gap under the fixed nav, or let the nav
// briefly cover the ad's top edge during the transition.
const NAV_FIXED_SCROLL_THRESHOLD = 200;
const HEADER_OFFSET = "top-[150px]";
const FIXED_NAV_OFFSET = "top-[41px]";

export default function SideAdRail({ children }: { children: React.ReactNode }) {
  const [isNavFixed, setIsNavFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsNavFixed(window.scrollY > NAV_FIXED_SCROLL_THRESHOLD);
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`hidden lg:block m-4 w-[160px] shrink-0 self-start sticky ${isNavFixed ? FIXED_NAV_OFFSET : HEADER_OFFSET}`}
    >
      {children}
    </div>
  );
}
